<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <v-checkbox v-model="fields.cardTitle.show" class="mb-2 mt-0" label="Show title block" hide-details />
          <label class="label-input mb-2 d-block">Title content</label>
          <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
        </div>

        <div class="mb-4">
          <label class="label-input">Images width</label>
          <v-text-field v-model.number="fields.listImages.width" type="number" suffix="px" min="20" hide-details />
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Images ({{ fields.listImages.items.length }})</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add image</span>
            </v-btn>
          </div>
          <v-row class="mt-2">
            <v-col
              v-for="(item, index) in fields.listImages.items"
              :key="`feetscare-list-image-item-${index}`"
              cols="6"
              md="3"
            >
              <div class="group-item">
                <UploadImage
                  @callback="payload => handleUploadItemImage(index, payload)"
                  :image="{ imageSrc: item.image }"
                  :height="'100'"
                  :typeUpload="'image'"
                  @callbackDelete="() => handleRemoveItemImage(index)"
                />
                <v-btn block small text color="error" class="mt-2" @click="handleRemoveItem(index)">
                  <v-icon size="16">mdi-delete</v-icon>
                  <span>Remove</span>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import { updateHtmlFromData } from '../common/html/update.js';

export default {
  name: 'feetscare-list-image-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Feetscare List Image',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#dc9376',
          textColor: '#FFFFFF',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardTitle: {
          show: true,
          content: '<h2>AS SEEN IN</h2><p>Trusted by millions of users worldwide</p>',
        },
        listImages: {
          width: 100,
          items: [],
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardTitle: { ...this.fields.cardTitle, ...(extract.cardTitle || {}) },
        listImages: {
          width: extract.listImages?.width ?? this.fields.listImages.width,
          items: Array.isArray(extract.listImages?.items) ? extract.listImages.items : this.fields.listImages.items,
        },
      };
    },
    handleAddItem() {
      this.fields.listImages.items.push({ image: '' });
    },
    handleRemoveItem(index) {
      this.fields.listImages.items.splice(index, 1);
    },
    handleUploadItemImage(index, payload) {
      if (payload?.imageSrc != null) {
        this.$set(this.fields.listImages.items[index], 'image', payload.imageSrc);
      }
    },
    handleRemoveItemImage(index) {
      this.$set(this.fields.listImages.items[index], 'image', '');
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFeetscareListImage(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
